import { ModalCustom } from "components/ModalCustom";
import { Icone, ModalBody } from "./style";
import { FaExclamation } from "react-icons/fa";

interface IProps {
  show: boolean;
  handleClose: () => void;
  onConfirm: () => void;
}

export function ModalCertezaReprovarLote({
  show,
  handleClose,
  onConfirm,
}: IProps) {
  return (
    <ModalCustom
      show={show}
      handleClose={handleClose}
      title="Reprovar lote"
      centered={true}
      footer={true}
      footerConfirmButton={true}
      onConfirm={onConfirm}
      confirmButtonText="Reprovar"
    >
      <ModalBody>
        <Icone>
          <FaExclamation />
        </Icone>
        Deseja reprovar o lote selecionado? Após a confirmação, o lote será
        excluído e os custos não serão lançados nos processos.
      </ModalBody>
    </ModalCustom>
  );
}
